import { combineReducers } from "redux";
import teamReducer from "./teamReducer";
import groupReducer from "./groupReducer";
import loaderReducer from "./loaderReducer";
import { createOrdersApi } from "../../app/services/lily";
import { taxyApis } from "../../app/services/taxy";

const rootReducers = combineReducers({
  team: teamReducer,
  groups: groupReducer,
  loader: loaderReducer,
  [createOrdersApi.reducerPath]: createOrdersApi.reducer,
  [taxyApis.reducerPath]: taxyApis.reducer,
});

export default rootReducers;
